if(window.location.pathname.indexOf('/challenge')===-1){
(()=>{
  const root=document.querySelector('[data-sl-assistant]');
  if(!root)return;

  const panel=root.querySelector('[data-sla-panel]');
  const body=root.querySelector('[data-sla-body]');
  const open=root.querySelector('[data-sla-open]');
  const WA_BASE='https://wa.me/393514181910?text=';
  const state={};

  const routes={
    home:{
      text:'👋 Ciao! Sono <strong>Lumi</strong>, l\'assistente di StripLED.<br>Dimmi cosa vuoi realizzare e ti aiuto a trovare la soluzione giusta.',
      options:[
        ['✨ Insegna Neon personalizzata','neonStart'],
        ['🪞 Specchio in acrilico personalizzato','mirrorStart'],
        ['💡 Devo scegliere una Strip LED','strip'],
        ['⬡ Luci LED esagonali','hex'],
        ['🔌 Calcolare un alimentatore','power'],
        ['🎛️ Controller e dimmer','control'],
        ['🧑‍🔧 Ho bisogno di un tecnico','tech']
      ]
    },

    neonStart:{
      text:'Perfetto ✨ Partiamo dalla tua idea. <strong>Cosa vuoi trasformare in neon?</strong>',
      options:[
        ['✍️ Una scritta','neonText','neonType','Scritta'],
        ['🖼️ Un logo','neonFile','neonType','Logo'],
        ['🎨 Un disegno o una forma','neonFile','neonType','Disegno / forma']
      ]
    },
    neonSize:{
      text:'Che dimensione indicativa vorresti? Se non sei sicuro, nessun problema: possiamo aiutarti noi.',
      options:[
        ['Piccola · 20–40 cm','neonColor','neonSize','20–40 cm'],
        ['Media · 40–70 cm','neonColor','neonSize','40–70 cm'],
        ['Grande · oltre 70 cm','neonColor','neonSize','Oltre 70 cm'],
        ['🤔 Non lo so ancora','neonColor','neonSize','Da definire']
      ]
    },
    neonColor:{
      text:'Che effetto luce hai in mente?',
      options:[
        ['🎨 Colore fisso','neonFixedColor'],
        ['✨ Digital RGB','neonUse','neonColor','Digital RGB'],
        ['🤔 Voglio un consiglio','neonUse','neonColor','Da consigliare']
      ]
    },
    neonFixedColor:{
      text:'Perfetto 🎨 <strong>Scegli uno dei colori disponibili</strong>.',
      options:[
        ['Bianco freddo','neonUse','neonColor','Bianco freddo'],
        ['Bianco caldo','neonUse','neonColor','Bianco caldo'],
        ['Rosa pesca','neonUse','neonColor','Rosa pesca'],
        ['Rosa','neonUse','neonColor','Rosa'],
        ['Rosso','neonUse','neonColor','Rosso'],
        ['Arancione','neonUse','neonColor','Arancione'],
        ['Giallo limone','neonUse','neonColor','Giallo limone'],
        ['Giallo oro','neonUse','neonColor','Giallo oro'],
        ['Verde','neonUse','neonColor','Verde'],
        ['Azzurro ghiaccio','neonUse','neonColor','Azzurro ghiaccio'],
        ['Blu','neonUse','neonColor','Blu'],
        ['Viola','neonUse','neonColor','Viola']
      ]
    },
    neonUse:{
      text:'Dove verrà installata l’insegna?',
      options:[
        ['🏠 Interno','neonFinish','neonUse','Interno'],
        ['☔ Esterno riparato','neonFinish','neonUse','Esterno riparato']
      ]
    },

    mirrorStart:{
      text:'Ottima scelta 🪞 Ti aiuto a impostare lo <strong>specchio personalizzato con neon in acrilico specchiato (non vetro)</strong>. Che forma preferisci?',
      options:[
        ['⚪ Rotondo','mirrorRoundSize','mirrorShape','Rotondo'],
        ['▭ Rettangolare','mirrorRectSize','mirrorShape','Rettangolare'],
        ['✂️ Sagomato / particolare','mirrorShapeFile','mirrorShape','Sagomato / particolare'],
        ['🤔 Non lo so ancora','mirrorContent','mirrorShape','Da definire']
      ]
    },
    mirrorRoundSize:{
      text:'Che diametro vorresti per lo specchio tondo?',
      options:[
        ['50 cm · misura minima','mirrorContent','mirrorSize','Ø 50 cm'],
        ['📏 Misura personalizzata','mirrorRoundCustom']
      ]
    },
    mirrorRectSize:{
      text:'Che misura vorresti per lo specchio rettangolare?',
      options:[
        ['70 × 50 cm','mirrorContent','mirrorSize','70 × 50 cm'],
        ['80 × 60 cm','mirrorContent','mirrorSize','80 × 60 cm'],
        ['📏 Misura personalizzata','mirrorRectCustom']
      ]
    },
    mirrorContent:{
      text:'Cosa vorresti illuminare sullo specchio?',
      options:[
        ['✍️ Una scritta','mirrorText','mirrorContent','Scritta'],
        ['🖼️ Un logo','mirrorFile','mirrorContent','Logo'],
        ['✨ Scritta + elemento grafico','mirrorTextGraphic','mirrorContent','Scritta + grafica']
      ]
    },
    mirrorColor:{
      text:'Che <strong>colore neon</strong> vorresti sullo specchio?',
      options:[
        ['Bianco freddo','mirrorFinish','mirrorColor','Bianco freddo'],
        ['Bianco caldo','mirrorFinish','mirrorColor','Bianco caldo'],
        ['Rosa pesca','mirrorFinish','mirrorColor','Rosa pesca'],
        ['Rosa','mirrorFinish','mirrorColor','Rosa'],
        ['Rosso','mirrorFinish','mirrorColor','Rosso'],
        ['Arancione','mirrorFinish','mirrorColor','Arancione'],
        ['Giallo limone','mirrorFinish','mirrorColor','Giallo limone'],
        ['Giallo oro','mirrorFinish','mirrorColor','Giallo oro'],
        ['Verde','mirrorFinish','mirrorColor','Verde'],
        ['Azzurro ghiaccio','mirrorFinish','mirrorColor','Azzurro ghiaccio'],
        ['Blu','mirrorFinish','mirrorColor','Blu'],
        ['Viola','mirrorFinish','mirrorColor','Viola'],
        ['✨ Digital RGB','mirrorFinish','mirrorColor','Digital RGB'],
        ['🤔 Voglio un consiglio','mirrorFinish','mirrorColor','Da consigliare']
      ]
    },

    strip:{text:'Ti serve una strip per un progetto standard oppure vuoi una soluzione già dimensionata su misura?',options:[['📏 Voglio scegliere la strip giusta','stripGuide'],['🛠️ Voglio una soluzione su misura','stripMade'],['🔌 Devo dimensionare l’alimentatore','power']]},
    stripGuide:{text:'Nella guida Strip LED trovi le soluzioni professionali e puoi confrontare le opzioni in base all’utilizzo.',actions:[['Scopri le Strip LED professionali','/pages/strip-led-professionali']]},
    stripMade:{text:'Per un impianto su misura puoi partire dal configuratore dedicato e indicare le caratteristiche del progetto.',actions:[['Vai a Strip LED su misura','/pages/strip-led-su-misura']]},
    power:{text:'Hai già <strong>lunghezza della strip</strong> e <strong>potenza in W/m</strong>? Il calcolatore ti aiuta a dimensionare l’alimentatore con il margine corretto.',actions:[['Apri calcolo alimentatore','/pages/calcolo-alimentatore-strip-led']]},
    hex:{
      text:'Perfetto ⬡ Ti preparo una richiesta già completa per il progetto LED esagonale. <strong>In che ambiente vuoi installarlo?</strong>',
      options:[
        ['🚗 Garage privato','hexLight','hexEnvironment','Garage privato'],
        ['✨ Centro car detailing','hexLight','hexEnvironment','Centro car detailing'],
        ['🔧 Officina / carrozzeria','hexLight','hexEnvironment','Officina / carrozzeria'],
        ['🏢 Showroom / altro','hexLight','hexEnvironment','Showroom / altro']
      ]
    },
    hexLight:{
      text:'Che tipo di illuminazione preferisci?',
      options:[
        ['❄️ Bianco freddo 6500K','hexDimensions','hexLight','Bianco freddo 6500K'],
        ['🌈 Digital RGB','hexDimensions','hexLight','Digital RGB'],
        ['🤔 Voglio un consiglio','hexDimensions','hexLight','Da consigliare']
      ]
    },
    hexCoverage:{
      text:'Quanto vuoi riempire il soffitto?',
      options:[
        ['💡 Illuminazione standard','hexComposition','hexCoverage','Standard'],
        ['🔥 Copertura più intensa','hexComposition','hexCoverage','Intensa'],
        ['🤔 Decidete voi','hexComposition','hexCoverage','Da consigliare']
      ]
    },
    hexComposition:{
      text:'Hai una preferenza per la composizione?',
      options:[
        ['⬡ Esagoni centrali','hexFinish','hexComposition','Esagoni centrali'],
        ['▦ Esagoni estesi','hexFinish','hexComposition','Esagoni estesi'],
        ['▭ Con cornice perimetrale','hexFinish','hexComposition','Con cornice perimetrale'],
        ['🤔 Voglio un consiglio','hexFinish','hexComposition','Da consigliare']
      ]
    },
    control:{text:'Per dimmer, controller e gestione delle Strip LED conviene partire dalla sezione dedicata. Se non sai quale scegliere, puoi anche chiedere supporto tecnico.',actions:[['Cerca controller e dimmer','/search?q=controller%20dimmer'],['Chiedi a un tecnico',()=>waLink('Ciao StripLED, Lumi mi ha indirizzato all’assistenza per controller e dimmer.'),'secondary']]},
    tech:{text:'Per un dubbio tecnico specifico puoi scriverci direttamente su WhatsApp. Indica cosa devi realizzare, tensione e metri di LED se li conosci.',actions:[['Scrivi su WhatsApp',()=>waLink('Ciao StripLED, ho bisogno di un consiglio tecnico dal sito.')]]}
  };

  function waLink(text){return WA_BASE+encodeURIComponent(text)}
  function track(name,label){try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'stripled_assistant_'+name,assistant_choice:label||''});}catch(e){}}
  function esc(v){return String(v||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));}
  function resetFlow(){Object.keys(state).forEach(k=>delete state[k]);}
  let currentView='home';
  const viewHistory=[];
  function navigate(key){
    if(currentView && currentView!==key)viewHistory.push(currentView);
    render(key);
  }
  function goBack(){
    const prev=viewHistory.pop();
    if(prev){render(prev);}
    else{render('home');}
  }


  function summaryCard(title,rows){
    return `<div class="sla__summary"><strong>${title}</strong>${rows.map(([k,v])=>`<div><span>${esc(k)}</span><b>${esc(v)}</b></div>`).join('')}</div>`;
  }

  function renderInputStep(config){
    body.innerHTML=`<div class="sla__bubble">${config.text}</div>`;
    const box=document.createElement('div');box.className='sla__inputbox';
    const label=document.createElement('label');label.className='sla__inputlabel';label.textContent=config.label;
    const input=document.createElement(config.multiline?'textarea':'input');
    input.className='sla__textinput';input.placeholder=config.placeholder||'';
    if(config.multiline){input.rows=3;input.maxLength=120;}else{input.type='text';input.maxLength=100;}
    if(state[config.stateKey])input.value=state[config.stateKey];
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua';
    btn.onclick=()=>{const val=input.value.trim();if(!val){input.focus();input.classList.add('sla__field-error');return;}state[config.stateKey]=val;track('input',config.label);navigate(config.next);};
    input.addEventListener('input',()=>input.classList.remove('sla__field-error'));
    box.append(label,input,btn);body.appendChild(box);addBack();setTimeout(()=>input.focus(),50);
  }

  function uploadToUploadcare(file){
    return new Promise((resolve,reject)=>{
      let attempts=0;
      const start=()=>{
        if(window.uploadcare&&typeof window.uploadcare.fileFrom==='function'){
          try{
            const upload=window.uploadcare.fileFrom('object',file);
            if(upload&&typeof upload.done==='function'){
              upload.done(resolve);
              if(typeof upload.fail==='function')upload.fail(reject);
              return;
            }
            if(upload&&typeof upload.then==='function'){
              upload.then(resolve,reject);
              return;
            }
            reject(new Error('Uploadcare non disponibile'));
          }catch(err){reject(err);}
          return;
        }
        attempts+=1;
        if(attempts<80){setTimeout(start,100);return;}
        reject(new Error('Uploadcare non caricato'));
      };
      start();
    });
  }

  function renderFileStep(config){
    body.innerHTML=`<div class="sla__bubble">${config.text}</div>`;
    const box=document.createElement('div');box.className='sla__uploadbox';
    const drop=document.createElement('label');drop.className='sla__dropzone';
    drop.innerHTML='<span class="sla__dropicon">＋</span><strong>Carica il file</strong><span>JPG, PNG, PDF o SVG · max 10 MB</span>';
    const input=document.createElement('input');input.type='file';input.accept='.jpg,.jpeg,.png,.pdf,.svg,image/jpeg,image/png,image/svg+xml,application/pdf';input.className='sla__fileinput';
    const status=document.createElement('div');status.className='sla__filestatus';
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua';btn.disabled=true;
    const urlKey=config.urlStateKey||config.stateKey+'Url';
    input.onchange=async()=>{
      const f=input.files&&input.files[0];
      if(!f)return;
      if(f.size>10*1024*1024){
        input.value='';delete state[config.stateKey];delete state[config.fileObjectKey];delete state[urlKey];
        status.textContent='Il file supera 10 MB. Scegline uno più piccolo.';status.classList.add('sla__fileerror');btn.disabled=true;return;
      }
      state[config.stateKey]=f.name;state[config.fileObjectKey]=f;delete state[urlKey];
      status.textContent='Caricamento su Uploadcare in corso…';status.classList.remove('sla__fileerror');btn.disabled=true;
      try{
        const info=await uploadToUploadcare(f);
        const url=(info&&info.cdnUrl)||'';
        if(!url)throw new Error('URL Uploadcare mancante');
        state[urlKey]=url;
        status.textContent='✓ File caricato: '+f.name;
        btn.disabled=false;
      }catch(err){
        delete state[urlKey];
        status.textContent='Caricamento non riuscito. Riprova selezionando di nuovo il file.';status.classList.add('sla__fileerror');btn.disabled=true;
      }
    };
    btn.onclick=()=>{if(!state[config.stateKey]||!state[urlKey]){input.click();return;}track('file',state[config.stateKey]);navigate(config.next);};
    drop.appendChild(input);box.append(drop,status,btn);body.appendChild(box);addBack();
  }

  function renderTextGraphicStep(){
    body.innerHTML='<div class="sla__bubble">Perfetto ✨ Scrivi il testo che vuoi sullo specchio. Subito dopo potrai aggiungere anche il file grafico.</div>';
    const box=document.createElement('div');box.className='sla__inputbox';
    const input=document.createElement('textarea');input.className='sla__textinput';input.rows=3;input.maxLength=120;input.placeholder='Es. BEAUTY ROOM';input.value=state.mirrorText||'';
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua e carica grafica';
    btn.onclick=()=>{const v=input.value.trim();if(!v){input.focus();input.classList.add('sla__field-error');return;}state.mirrorText=v;navigate('mirrorGraphicFile');};
    input.addEventListener('input',()=>input.classList.remove('sla__field-error'));box.append(input,btn);body.appendChild(box);addBack();setTimeout(()=>input.focus(),50);
  }

  function renderDimensionsStep(){
    body.innerHTML='<div class="sla__bubble">Indicami le <strong>misure del soffitto</strong>. Bastano valori indicativi.</div>';
    const box=document.createElement('div');box.className='sla__inputbox';
    box.innerHTML='<div class="sla__fieldgrid"><label class="sla__inputlabel">Larghezza (m)<input class="sla__textinput" data-dim="w" type="number" min="1" max="30" step="0.1" placeholder="Es. 4"></label><label class="sla__inputlabel">Profondità (m)<input class="sla__textinput" data-dim="d" type="number" min="1" max="30" step="0.1" placeholder="Es. 6"></label><label class="sla__inputlabel">Altezza (m) <span>(facoltativa)</span><input class="sla__textinput" data-dim="h" type="number" min="1.8" max="15" step="0.1" placeholder="Es. 3"></label></div>';
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua';
    btn.onclick=()=>{const w=box.querySelector('[data-dim="w"]'),d=box.querySelector('[data-dim="d"]'),h=box.querySelector('[data-dim="h"]');if(!w.value||!d.value){[w,d].forEach(i=>{if(!i.value)i.classList.add('sla__field-error')});return;}state.hexWidth=w.value;state.hexDepth=d.value;state.hexHeight=h.value||'Da definire';navigate('hexCoverage');};
    box.querySelectorAll('input').forEach(i=>i.addEventListener('input',()=>i.classList.remove('sla__field-error')));box.appendChild(btn);body.appendChild(box);addBack();
  }

  function renderMirrorRoundCustom(){
    body.innerHTML='<div class="sla__bubble">Inserisci il <strong>diametro personalizzato</strong> dello specchio tondo. La misura minima è 50 cm.</div>';
    const box=document.createElement('div');box.className='sla__inputbox';box.innerHTML='<label class="sla__inputlabel">Diametro (cm)<input class="sla__textinput" type="number" min="50" max="300" step="1" data-round-diameter placeholder="Es. 70"></label>';
    const input=box.querySelector('[data-round-diameter]');if(state.mirrorDiameterCustom)input.value=state.mirrorDiameterCustom;
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua';
    btn.onclick=()=>{const v=parseFloat(input.value);if(!v||v<50){input.classList.add('sla__field-error');input.focus();return;}state.mirrorDiameterCustom=String(v);state.mirrorSize='Ø '+v+' cm';navigate('mirrorContent');};
    input.addEventListener('input',()=>input.classList.remove('sla__field-error'));box.appendChild(btn);body.appendChild(box);addBack();setTimeout(()=>input.focus(),50);
  }
  function renderMirrorRectCustom(){
    body.innerHTML='<div class="sla__bubble">Inserisci le <strong>misure personalizzate</strong> dello specchio rettangolare.</div>';
    const box=document.createElement('div');box.className='sla__inputbox';box.innerHTML='<div class="sla__fieldgrid"><label class="sla__inputlabel">Larghezza (cm)<input class="sla__textinput" type="number" min="1" max="300" step="1" data-rect-w placeholder="Es. 90"></label><label class="sla__inputlabel">Altezza (cm)<input class="sla__textinput" type="number" min="1" max="300" step="1" data-rect-h placeholder="Es. 70"></label></div>';
    const w=box.querySelector('[data-rect-w]'),h=box.querySelector('[data-rect-h]');if(state.mirrorRectW)w.value=state.mirrorRectW;if(state.mirrorRectH)h.value=state.mirrorRectH;
    const btn=document.createElement('button');btn.type='button';btn.className='sla__action';btn.textContent='Continua';
    btn.onclick=()=>{if(!w.value||!h.value){[w,h].forEach(i=>{if(!i.value)i.classList.add('sla__field-error')});return;}state.mirrorRectW=w.value;state.mirrorRectH=h.value;state.mirrorSize=w.value+' × '+h.value+' cm';navigate('mirrorContent');};
    [w,h].forEach(i=>i.addEventListener('input',()=>i.classList.remove('sla__field-error')));box.appendChild(btn);body.appendChild(box);addBack();setTimeout(()=>w.focus(),50);
  }
  function projectRows(kind){
    if(kind==='neon')return [['Progetto',state.neonType],...(state.neonText?[['Testo',state.neonText]]:[]),...(state.neonFile?[['File',state.neonFile]]:[]),['Misura',state.neonSize],['Colore',state.neonColor],['Utilizzo',state.neonUse]];
    if(kind==='mirror')return [['Materiale','Acrilico specchiato (non vetro)'],['Forma',state.mirrorShape],...(state.mirrorSize?[['Misura',state.mirrorSize]]:[]),...(state.mirrorShapeFile?[['File forma',state.mirrorShapeFile]]:[]),['Personalizzazione',state.mirrorContent],...(state.mirrorColor?[['Colore neon',state.mirrorColor]]:[]),...(state.mirrorText?[['Testo',state.mirrorText]]:[]),...(state.mirrorFile?[['File personalizzazione',state.mirrorFile]]:[])];
    return [['Ambiente',state.hexEnvironment],['LED',state.hexLight],['Soffitto',`${state.hexWidth} × ${state.hexDepth} m`],['Altezza',state.hexHeight==='Da definire'?state.hexHeight:`${state.hexHeight} m`],['Copertura',state.hexCoverage],['Composizione',state.hexComposition]];
  }

  function renderContactStep(kind){
    const rows=projectRows(kind);
    const labels={neon:'insegna Neon',mirror:'specchio in acrilico personalizzato',hex:'progetto LED esagonale'};
    body.innerHTML=`<div class="sla__bubble">Perfetto. Ho tutto quello che mi serve per il tuo <strong>${labels[kind]}</strong>.<br><br>Dove possiamo inviarti il preventivo?</div>${summaryCard('Riepilogo',rows)}`;
    const form=document.createElement('form');form.className='sla__inputbox sla__contactform';form.noValidate=true;
    form.innerHTML=`<label class="sla__inputlabel">Email <strong>*</strong><input class="sla__textinput" type="email" name="email" autocomplete="email" placeholder="nome@email.it" required></label><label class="sla__inputlabel">WhatsApp <span>(facoltativo)</span><input class="sla__textinput" type="tel" name="phone" autocomplete="tel" placeholder="+39..."></label><label class="sla__inputlabel">Note <span>(facoltative)</span><textarea class="sla__textinput sla__notes" name="notes" rows="3" maxlength="500" placeholder="Aggiungi dettagli, richieste particolari o informazioni utili...">${state.notes||''}</textarea></label><label class="sla__privacy"><input type="checkbox" name="privacy" required><span>Ho letto l’<a href="/policies/privacy-policy" target="_blank" rel="noopener">informativa privacy</a> e acconsento al trattamento dei dati per ricevere il preventivo.</span></label><div class="sla__formstatus" aria-live="polite"></div><button type="submit" class="sla__action sla__final-submit">Invia richiesta di preventivo</button>`;
    form.onsubmit=(e)=>{
      e.preventDefault();
      const email=form.email.value.trim(),phone=form.phone.value.trim(),notes=form.notes.value.trim(),privacy=form.privacy.checked,status=form.querySelector('.sla__formstatus'),btn=form.querySelector('button[type="submit"]');
      state.notes=notes;
      if(!email||!form.email.validity.valid){form.email.focus();form.email.classList.add('sla__field-error');status.textContent='Inserisci un indirizzo email valido.';return;}
      if(!privacy){status.textContent='Per inviare la richiesta devi accettare l’informativa privacy.';return;}
      const native=document.getElementById('LumiContactForm');
      if(!native){status.textContent='Modulo Shopify non disponibile. Ricarica la pagina e riprova.';return;}
      const title=kind==='neon'?'Richiesta preventivo Neon da Lumi':kind==='mirror'?'Richiesta preventivo Specchio in acrilico da Lumi':'Richiesta progetto LED esagonali da Lumi';
      const attribution=window.StripledAttribution?window.StripledAttribution.get():{};
      const uploadRows=[];
      if(kind==='neon'&&state.neonFileUrl)uploadRows.push(['File Uploadcare',state.neonFileUrl]);
      if(kind==='mirror'&&state.mirrorShapeFileUrl)uploadRows.push(['File forma Uploadcare',state.mirrorShapeFileUrl]);
      if(kind==='mirror'&&state.mirrorFileUrl)uploadRows.push(['File personalizzazione Uploadcare',state.mirrorFileUrl]);
      const uploadUrls=uploadRows.map(row=>row[1]);
      const bodyText=[title,'',...rows.map(([k,v])=>`${k}: ${v}`),...(uploadRows.length?['',...uploadRows.map(([k,v])=>`${k}: ${v}`)]:[]),'',`Note: ${notes||'Nessuna'}`,`Email: ${email}`,`WhatsApp: ${phone||'Non indicato'}`,'Consenso privacy: Accettato','',`Canale acquisizione: ${attribution.channel||'-'}`,`Tipo accesso conversione: ${attribution.conversionAccess||'-'}`,`Pagina ingresso: ${attribution.entryPage||'-'}`,`Referrer iniziale: ${attribution.initialReferrer||'-'}`,`Pagina precedente: ${attribution.previousPage||'-'}`,`Pagina invio: ${attribution.conversionPage||window.location.href}`,`UTM source: ${attribution.utmSource||'-'}`,`UTM medium: ${attribution.utmMedium||'-'}`,`UTM campaign: ${attribution.utmCampaign||'-'}`,`UTM content: ${attribution.utmContent||'-'}`,`UTM term: ${attribution.utmTerm||'-'}`].join('\n');
      native.querySelector('[data-sla-native-email]').value=email;
      native.querySelector('[data-sla-native-phone]').value=phone;
      const nativeFile=native.querySelector('[data-sla-native-file]');if(nativeFile)nativeFile.value=uploadUrls[0]||'';
      const nativeFile2=native.querySelector('[data-sla-native-file-2]');if(nativeFile2)nativeFile2.value=uploadUrls[1]||'';
      native.querySelector('[data-sla-native-tags]').value=kind==='hex'?'preventivo-led-esagonali,lumi,origine-lumi':kind==='mirror'?'preventivo-specchio-neon,lumi,origine-lumi':'preventivo-neon,lumi,origine-lumi';
      native.querySelector('[data-sla-native-subject]').value=title;
      native.querySelector('[data-sla-native-body]').value=bodyText;
      try{sessionStorage.setItem('sla_pending_submit',JSON.stringify({kind,email,phone,rows:notes?[...rows,['Note',notes]]:rows}));}catch(err){}
      btn.disabled=true;btn.textContent='Invio in corso…';status.textContent='';track('lead_submit',kind);
      let sent=false;
      const actuallySubmit=()=>{
        if(sent)return;
        sent=true;
        try{native.submit();}catch(submitErr){
          sent=false;
          btn.disabled=false;btn.textContent='Invia richiesta di preventivo';
          status.textContent='Non sono riuscito a completare l’invio. Riprova tra qualche secondo.';
          try{sessionStorage.removeItem('sla_pending_submit')}catch(err){}
        }
      };
      const safetyTimer=setTimeout(()=>{
        if(sent)return;
        btn.disabled=false;btn.textContent='Riprova invio';
        status.textContent='L’invio sta impiegando troppo tempo. Premi “Riprova invio”.';
        try{sessionStorage.removeItem('sla_pending_submit')}catch(err){}
      },12000);
      try{
        if(window.Shopify&&Shopify.captcha&&typeof Shopify.captcha.protect==='function'){
          Shopify.captcha.protect(native,()=>{clearTimeout(safetyTimer);actuallySubmit();});
        }else{
          clearTimeout(safetyTimer);
          actuallySubmit();
        }
      }catch(captchaErr){
        clearTimeout(safetyTimer);
        actuallySubmit();
      }
    };
    form.email.addEventListener('input',()=>form.email.classList.remove('sla__field-error'));body.appendChild(form);addBack();
  }

  function showSuccessPopup(){const old=document.getElementById('sl-success-popup');if(old)old.remove();const pop=document.createElement('div');pop.id='sl-success-popup';pop.className='sl-success-popup';pop.innerHTML='<div class="sl-success-card"><div class="sl-success-check">✓</div><strong>Richiesta inviata!</strong><p>Grazie! Abbiamo ricevuto la tua richiesta.<br>Ti ricontatteremo il prima possibile.</p><button type="button" class="sl-success-close">Chiudi</button></div>';document.body.appendChild(pop);requestAnimationFrame(()=>pop.classList.add('is-visible'));const close=()=>{pop.classList.remove('is-visible');setTimeout(()=>pop.remove(),220)};pop.querySelector('.sl-success-close').onclick=close;pop.onclick=e=>{if(e.target===pop)close()};}
  function renderFinish(kind){
    body.innerHTML='';
    if(kind==='neon'){
      const rows=[['Progetto',state.neonType],...(state.neonText?[['Testo',state.neonText]]:[]),...(state.neonFile?[['File',state.neonFile]]:[]),['Misura',state.neonSize],['Colore',state.neonColor],['Utilizzo',state.neonUse]];
      body.insertAdjacentHTML('beforeend',`<div class="sla__bubble">Perfetto! Ho già raccolto le informazioni principali. Puoi ora inviare la richiesta di preventivo e completarla con gli ultimi dettagli.</div>${summaryCard('Il tuo progetto',rows)}`);
      addAction('Richiedi preventivo gratuito','/pages/insegne-neon-led-personalizzate');
      if(state.neonType==='Scritta') addAction('Vedi anche i configuratori','/pages/led-su-misura-configuratori','secondary');
      const msg=`Ciao StripLED, sto configurando un neon con Lumi. Progetto: ${state.neonType}${state.neonText?`; testo: ${state.neonText}`:''}${state.neonFile?`; file selezionato: ${state.neonFile}`:''}; misura: ${state.neonSize}; colore: ${state.neonColor}; utilizzo: ${state.neonUse}. Vorrei un consiglio.`;
      addAction('Chiedi un consiglio su WhatsApp',waLink(msg),'secondary');
    } else {
      const rows=[['Materiale','Acrilico specchiato (non vetro)'],['Forma',state.mirrorShape],['Misura',state.mirrorSize],['Personalizzazione',state.mirrorContent],...(state.mirrorText?[['Testo',state.mirrorText]]:[]),...(state.mirrorFile?[['File',state.mirrorFile]]:[])];
      body.insertAdjacentHTML('beforeend',`<div class="sla__bubble">Perfetto 🪞 Hai già definito una buona base per il tuo specchio in acrilico. Nella pagina dedicata puoi proseguire con la richiesta personalizzata.</div>${summaryCard('Il tuo specchio in acrilico',rows)}`);
      addAction('Vai agli specchi in acrilico personalizzati','/pages/specchi-con-scritta-neon-personalizzata');
      const msg=`Ciao StripLED, sto configurando uno specchio in acrilico specchiato (non vetro) con Lumi. Forma: ${state.mirrorShape}; misura: ${state.mirrorSize}; personalizzazione: ${state.mirrorContent}${state.mirrorText?`; testo: ${state.mirrorText}`:''}${state.mirrorFile?`; file selezionato: ${state.mirrorFile}`:''}. Vorrei un consiglio.`;
      addAction('Chiedi un consiglio su WhatsApp',waLink(msg),'secondary');
    }
    addBack();
  }

  function addAction(label,url,kind){
    const a=document.createElement('a');
    a.className='sla__action'+(kind?' sla__action--secondary':'');
    a.href=typeof url==='function'?url():url;
    if(a.href.startsWith('http')){a.target='_blank';a.rel='noopener';}
    a.textContent=label;
    a.onclick=()=>track('cta',label);
    body.appendChild(a);
  }

  function addBack(){
    const back=document.createElement('button');
    back.type='button';back.className='sla__back';back.textContent='← Torna indietro';
    back.onclick=goBack;
    body.appendChild(back);
  }

  function render(key){
    currentView=key;

    if(key==='neonText')return renderInputStep({text:'Certo ✍️ <strong>Scrivi qui il testo esatto</strong> che vorresti trasformare in neon.',label:'Testo dell’insegna',placeholder:'Es. Villa Floris',stateKey:'neonText',next:'neonSize',multiline:true});
    if(key==='neonFile')return renderFileStep({text:'Perfetto 🖼️ <strong>Carica qui il logo, disegno o bozza</strong> che vuoi trasformare in neon.',stateKey:'neonFile',fileObjectKey:'neonFileObject',urlStateKey:'neonFileUrl',next:'neonSize'});
    if(key==='mirrorRoundCustom')return renderMirrorRoundCustom();
    if(key==='mirrorRectCustom')return renderMirrorRectCustom();
    if(key==='mirrorShapeFile')return renderFileStep({text:'Perfetto ✂️ <strong>Carica un file con la forma, il logo, il disegno o una bozza</strong> dello specchio sagomato che vorresti realizzare.',stateKey:'mirrorShapeFile',fileObjectKey:'mirrorShapeFileObject',urlStateKey:'mirrorShapeFileUrl',next:'mirrorContent'});
    if(key==='mirrorText')return renderInputStep({text:'Perfetto ✍️ <strong>Scrivi qui il testo esatto</strong> che vorresti vedere sullo specchio.',label:'Testo sullo specchio',placeholder:'Es. Guarda chi si vede',stateKey:'mirrorText',next:'mirrorColor',multiline:true});
    if(key==='mirrorFile')return renderFileStep({text:'Perfetto 🖼️ <strong>Carica qui il logo o la grafica</strong> che vuoi inserire sullo specchio.',stateKey:'mirrorFile',fileObjectKey:'mirrorFileObject',urlStateKey:'mirrorFileUrl',next:'mirrorColor'});
    if(key==='mirrorGraphicFile')return renderFileStep({text:'Ora aggiungi il logo, simbolo o elemento grafico da inserire insieme alla scritta.',stateKey:'mirrorFile',fileObjectKey:'mirrorFileObject',urlStateKey:'mirrorFileUrl',next:'mirrorColor'});
    if(key==='mirrorTextGraphic')return renderTextGraphicStep();
    if(key==='neonFinish')return renderContactStep('neon');
    if(key==='mirrorFinish')return renderContactStep('mirror');
    if(key==='hexDimensions')return renderDimensionsStep();
    if(key==='hexFinish')return renderContactStep('hex');
    const p=routes[key]||routes.home;
    body.innerHTML=`<div class="sla__bubble">${p.text}</div>`;
    if(p.options){
      const wrap=document.createElement('div');wrap.className='sla__options';
      p.options.forEach(([label,next,stateKey,stateVal])=>{
        const b=document.createElement('button');b.type='button';b.className='sla__option';
        if((key==='neonFixedColor'||key==='mirrorColor')&&stateVal&&stateVal!=='Digital RGB'&&stateVal!=='Da consigliare'){
          b.classList.add('sla__color-option');
          const sw=document.createElement('span');sw.className='sla__swatch';sw.setAttribute('data-neon-color',stateVal);
          const tx=document.createElement('span');tx.textContent=label;
          b.append(sw,tx);
        }else{b.textContent=label;}
        b.onclick=()=>{if(stateKey)state[stateKey]=stateVal;track('choice',label);navigate(next)};
        wrap.appendChild(b);
      });
      body.appendChild(wrap);
    }
    if(p.actions){p.actions.forEach(([label,url,kind])=>addAction(label,url,kind));}
    if(key!=='home')addBack();
  }

  function show(){if(typeof pauseLumiIdle==='function')pauseLumiIdle();panel.hidden=false;open.setAttribute('aria-expanded','true');resetFlow();viewHistory.length=0;render('home');track('open');}
  function hide(){panel.hidden=true;open.setAttribute('aria-expanded','false');if(typeof resumeLumiIdle==='function')resumeLumiIdle()}
  open.addEventListener('click',()=>panel.hidden?show():hide());
  root.querySelector('[data-sla-close]').addEventListener('click',hide);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden)hide()});
  render('home');

  function suppressOtherContactSuccess(){
    document.body.classList.add('sla-lumi-success');
    document.querySelectorAll(
      '[data-slc-success-modal], .slc-form__status, .nc-success-box, .mp-success-box, .hex-form-success, .contact .form-status.form__message'
    ).forEach(el=>{el.hidden=true;el.style.setProperty('display','none','important');});
    document.body.classList.remove('slc-success-open');
  }

  const nativePosted=document.querySelector('[data-sla-posted-success]');
  const nativeErrors=document.querySelector('[data-sla-posted-errors]');
  let pending=null;try{pending=JSON.parse(sessionStorage.getItem('sla_pending_submit')||'null')}catch(e){}
  if(nativePosted&&pending){
    state.contactEmail=pending.email||'';state.contactPhone=pending.phone||'';
    suppressOtherContactSuccess();
    try{sessionStorage.removeItem('sla_pending_submit')}catch(e){}
    setTimeout(()=>{suppressOtherContactSuccess();showSuccessPopup();},120);
  }else if(nativeErrors&&pending){
    try{sessionStorage.removeItem('sla_pending_submit')}catch(e){}
    setTimeout(()=>{show();const msg=nativeErrors.textContent.trim()||'Shopify non ha accettato la richiesta.';body.innerHTML='<div class="sla__bubble"><strong>Invio non completato.</strong><br>'+esc(msg)+'</div>';addBack();},250);
  }


  /* Lumi idle personality: animazioni brevi e casuali solo quando il pannello è chiuso. */
  const idleFace=root.querySelector('.sla__launcher .sla__face');
  const reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lumiIdleTimer=null;
  let lumiActionTimers=[];

  function clearLumiActionTimers(){
    lumiActionTimers.forEach(t=>clearTimeout(t));
    lumiActionTimers=[];
    if(!idleFace)return;
    idleFace.classList.remove('sla-is-blinking','sla-look-left','sla-look-right','sla-bored-tilt');
  }

  function later(fn,ms){
    const t=setTimeout(fn,ms);
    lumiActionTimers.push(t);
    return t;
  }

  function lumiCanIdle(){
    return !!idleFace && !reduceMotion && panel.hidden && document.visibilityState==='visible';
  }

  function lumiBlink(doubleBlink){
    if(!lumiCanIdle())return;
    idleFace.classList.add('sla-is-blinking');
    later(()=>idleFace.classList.remove('sla-is-blinking'),125);
    if(doubleBlink){
      later(()=>idleFace.classList.add('sla-is-blinking'),285);
      later(()=>idleFace.classList.remove('sla-is-blinking'),410);
    }
  }

  function lumiGlance(){
    if(!lumiCanIdle())return;
    const first=Math.random()<.5?'sla-look-left':'sla-look-right';
    const second=first==='sla-look-left'?'sla-look-right':'sla-look-left';
    idleFace.classList.add('sla-bored-tilt',first);
    later(()=>{
      idleFace.classList.remove(first);
      idleFace.classList.add(second);
    },850);
    later(()=>{
      idleFace.classList.remove(second,'sla-bored-tilt');
    },1700);
    later(()=>lumiBlink(false),1950);
  }

  function scheduleLumiIdle(delay){
    if(reduceMotion||!idleFace)return;
    clearTimeout(lumiIdleTimer);
    lumiIdleTimer=setTimeout(()=>{
      clearLumiActionTimers();
      if(lumiCanIdle()){
        const roll=Math.random();
        if(roll<.62) lumiBlink(Math.random()<.18);
        else lumiGlance();
      }
      scheduleLumiIdle(7000+Math.random()*9000);
    }, delay==null ? 6500+Math.random()*5000 : delay);
  }

  function pauseLumiIdle(){
    clearTimeout(lumiIdleTimer);
    clearLumiActionTimers();
  }

  function resumeLumiIdle(){
    if(panel.hidden) scheduleLumiIdle(4500+Math.random()*4500);
  }

  if(idleFace&&!reduceMotion){
    scheduleLumiIdle(5500+Math.random()*3500);
    open.addEventListener('mouseenter',pauseLumiIdle);
    open.addEventListener('mouseleave',resumeLumiIdle);
    open.addEventListener('focus',pauseLumiIdle);
    open.addEventListener('blur',resumeLumiIdle);
    document.addEventListener('visibilitychange',()=>{
      if(document.visibilityState==='visible') resumeLumiIdle();
      else pauseLumiIdle();
    });
  }

  const hello=root.querySelector('[data-sla-hello]');
  if(hello){
    let helloShown=false;
    setTimeout(()=>{if(panel.hidden&&!helloShown){helloShown=true;hello.hidden=false;setTimeout(()=>{hello.hidden=true},6500)}},3500);
    hello.addEventListener('click',()=>{hello.hidden=true;show()});
    open.addEventListener('click',()=>hello.hidden=true);
  }
})();

}
